import React from "react";
import { FakeBannerAppRoot } from "./FakeBannerApp.styled";

interface IFakeBannerAppProps {
  title: string;
  app_rating_value: number;
  app_rating_count: number;
  cta: string;
  noteLabel: string;
  buttonLabel: string;
  onClose?: () => void;
  onOpen?: () => void;
}

const FakeBannerApp = (props: IFakeBannerAppProps) => {
  const {
    title,
    app_rating_value,
    app_rating_count,
    cta,
    noteLabel,
    buttonLabel,
    onClose,
    onOpen,
  } = props;

  return (
    <FakeBannerAppRoot className="fake-banner-app">
      <button type="button" className="close" onClick={onClose}>
        <i className="icon icon-cross-close"></i>
      </button>
      <label className="fake-banner-app__icon" htmlFor="fake-banner-app-button">
        <i className="icon icon-logo"></i>
      </label>
      <label
        htmlFor="fake-banner-app-button"
        className="fake-banner-app__labels"
      >
        <div className="fake-banner-app__name">{title}</div>
        <div className="fake-banner-app__rating">
          {Array.from({ length: 5 }).map((_, index) => {
            const c = app_rating_value - index;
            const p = c > 1 ? 1 : c < 0 ? 0 : c;
            return <span className="fake-banner-app__star" data-p={p}></span>;
          })}
          {/* Note, UI */}
          <span
            className="fake-banner-app__rating__value o75"
            data-count={app_rating_value}
          >
            {noteLabel} :{" "}
            {app_rating_value ? app_rating_value.toLocaleString() : ""}
          </span>
          <span
            className="fake-banner-app__rating__count-icon"
            data-count={app_rating_count}
          ></span>
          <span className="fake-banner-app__rating__count o75">
            {app_rating_count ? app_rating_count.toLocaleString() : ""}
          </span>
        </div>
        <div className="fake-banner-app__cta o75">{cta}</div>
      </label>
      
      {/* 'Afficher','UI' */}
      <button
        id="fake-banner-app-button"
        type="button"
        className="fake-banner-app__display-button"
        onClick={onOpen}
      >
        {buttonLabel}
      </button>
    </FakeBannerAppRoot>
  );
};

export default FakeBannerApp;
